#### Suspend status on posted position profiles

We’ve added a [`seekStatusCode`] field to [`PostedPositionProfile`].

Include this field when querying a job ad after a [`PositionProfileUpdated`] event to determine whether the ad is `Active` or `Suspended`.

In rare cases, SEEK may suspend a live job ad (for example due to duplicate ads or content issues) and emit another `PositionProfileUpdated` event.
Your software can surface this status to hirers and include a call to action to contact SEEK.

See [Display job ads] for more detail on the Ad Sync lifecycle.

[`seekStatusCode`]: /schema/named-type/PostedPositionProfile#/field/seekStatusCode
[`PostedPositionProfile`]: /schema/named-type/PostedPositionProfile
[`PositionProfileUpdated`]: /schema/webhooks/PositionProfileUpdatedEvent
[Display job ads]: /use-cases/job-posting/ad-sync/display-job-ads#positionprofileupdated
